// extracted by mini-css-extract-plugin
export default {"whyChooseContainer":"WhyChoose_whyChooseContainer__IyWxp","whyChoose":"WhyChoose_whyChoose__3mmHY","card":"WhyChoose_card__ILUBg"};